var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgHeart = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M2.063 6.761c0 .983.397 1.875 1.042 2.52L9 15.176l5.895-5.895a3.55 3.55 0 0 0 1.043-2.52A3.56 3.56 0 0 0 9 5.63a3.562 3.562 0 0 0-6.937 1.13Z" }) }))); };
export default SvgHeart;
